import { t as e } from "./utils-DQJjwn-K.js";
import { AppWindow as t, BarChart3 as n, Bot as r, Code as i, Compass as a, Database as o, File as s, FileJson as c, FileSpreadsheet as l, FileText as u, FileUp as d, Files as f, GraduationCap as p, Library as m, Lightbulb as h, Map as g, MessageCircle as _, ScreenShare as v, Sparkles as y, SquareTerminal as b, Table as x, Wand2 as S } from "lucide-react";
import { jsx as C } from "react/jsx-runtime";
//#region src/lib/icons/feature-icons.tsx
var w = {
	bg: "bg-muted",
	icon: "text-muted-foreground"
}, T = {
	conversation: {
		Icon: _,
		tile: w
	},
	skill: {
		Icon: p,
		color: "text-violet-600 dark:text-violet-400",
		tile: {
			bg: "bg-violet-50 dark:bg-violet-950/40",
			icon: "text-violet-600 dark:text-violet-400"
		}
	},
	agent: {
		Icon: r,
		color: "text-amber-600 dark:text-amber-400",
		tile: {
			bg: "bg-amber-50 dark:bg-amber-950/40",
			icon: "text-amber-600 dark:text-amber-400"
		}
	},
	artifact: {
		Icon: v,
		color: "text-indigo-600 dark:text-indigo-400",
		tile: {
			bg: "bg-indigo-50 dark:bg-indigo-950/40",
			icon: "text-indigo-600 dark:text-indigo-400"
		}
	},
	file: {
		Icon: f,
		tile: w
	},
	sandbox: {
		Icon: b,
		tile: w
	}
};
function E(e) {
	return T[e];
}
//#endregion
//#region src/lib/icons/artifact-type-icons.tsx
var D = {
	Icon: t,
	color: "text-pink-600 dark:text-pink-400",
	bg: {
		base: "bg-pink-500/10",
		hover: "group-hover:bg-pink-500/20"
	}
}, O = {
	map: {
		Icon: g,
		color: "text-blue-600 dark:text-blue-400",
		bg: {
			base: "bg-blue-500/10",
			hover: "group-hover:bg-blue-500/20"
		}
	},
	table: {
		Icon: x,
		color: "text-green-600 dark:text-green-400",
		bg: {
			base: "bg-green-500/10",
			hover: "group-hover:bg-green-500/20"
		}
	},
	chart: {
		Icon: n,
		color: "text-purple-600 dark:text-purple-400",
		bg: {
			base: "bg-purple-500/10",
			hover: "group-hover:bg-purple-500/20"
		}
	},
	webpage: D,
	html: D
}, k = {
	Icon: v,
	color: "text-muted-foreground",
	bg: {
		base: "bg-muted-foreground/10",
		hover: "group-hover:bg-muted-foreground/20"
	}
};
function A(e) {
	return O[e] ?? k;
}
var j = {
	sm: "h-4 w-4",
	md: "h-5 w-5",
	lg: "h-12 w-12"
};
function M(e) {
	return A(e).bg;
}
function N({ type: t, size: n = "md", className: r }) {
	let { Icon: i, color: a } = A(t);
	return /* @__PURE__ */ C(i, { className: e(j[n], a, r) });
}
//#endregion
//#region src/lib/icons/file-type-icons.ts
var P = {
	csv: l,
	xlsx: l,
	json: c,
	geojson: c,
	parquet: o
};
function F(e) {
	return {
		Icon: P[e.split(".").pop()?.toLowerCase() ?? ""] ?? u,
		color: "text-muted-foreground"
	};
}
//#endregion
//#region src/lib/icons/action-icons.ts
var I = { ai: { Icon: y } };
function L(e) {
	return I[e];
}
//#endregion
//#region src/lib/icons/suggestion-icons.ts
var R = {
	lightbulb: { Icon: h },
	map: { Icon: g },
	barChart: { Icon: n },
	fileUp: { Icon: d },
	library: { Icon: m },
	compass: { Icon: a },
	wand: { Icon: S }
};
function z(e) {
	return R[e];
}
//#endregion
//#region src/lib/icons/icon-tile.tsx
var B = {
	sm: {
		tile: "h-8 w-8 rounded-lg",
		icon: "h-4 w-4"
	},
	md: {
		tile: "size-9 rounded-lg",
		icon: "size-4.5"
	},
	lg: {
		tile: "size-14 rounded-2xl",
		icon: "size-7"
	}
};
function V({ feature: t, size: n = "sm", className: r }) {
	let { Icon: i, tile: a } = E(t), o = B[n];
	return /* @__PURE__ */ C("div", {
		className: e("flex shrink-0 items-center justify-center", o.tile, a.bg, r),
		children: /* @__PURE__ */ C(i, {
			className: e(o.icon, a.icon),
			"aria-hidden": "true"
		})
	});
}
//#endregion
//#region src/lib/skill-files.ts
var H = {
	readme: u,
	skill: E("skill").Icon,
	markdown: u,
	code: i,
	other: s
};
function U(e) {
	return e.split("/").at(-1) ?? e;
}
function W(e) {
	let t = U(e), n = t.lastIndexOf(".");
	return n === -1 ? "" : t.slice(n + 1).toLowerCase();
}
function G(e) {
	return W(e) === "md";
}
var K = new Set([
	"py",
	"js",
	"mjs",
	"cjs",
	"ts",
	"tsx",
	"jsx",
	"json",
	"sh",
	"bash",
	"yaml",
	"yml",
	"toml",
	"ini",
	"cfg",
	"html",
	"htm",
	"css",
	"sql",
	"rb",
	"go",
	"rs",
	"java",
	"csv",
	"txt"
]), q = /^readme(\.[\w-]+)?\.md$/;
function J(e) {
	let t = U(e).toLowerCase();
	return q.test(t) ? "readme" : t === "skill.md" ? "skill" : G(e) ? "markdown" : K.has(W(e)) ? "code" : "other";
}
function Y(e) {
	return e.some((e) => J(e) === "readme");
}
function X(e, t) {
	let n = t?.split(/[-_]/)[0].toLowerCase(), r = (t) => e.find((e) => U(e).toLowerCase() === t);
	return (n ? r(`readme.${n}.md`) : void 0) ?? r("readme.en.md") ?? r("readme.md") ?? e.find((e) => J(e) === "skill") ?? e[0];
}
function Z(e) {
	let t = /^\uFEFF?---[ \t]*\r?\n([\s\S]*?)\r?\n---[ \t]*(?:\r?\n([\s\S]*))?$/.exec(e);
	return t ? {
		frontmatter: t[1],
		body: (t[2] ?? "").replace(/^\r?\n/, "")
	} : {
		frontmatter: void 0,
		body: e
	};
}
function Q(e, t) {
	return `---\n${e}\n---\n\n${t}`;
}
//#endregion
export { Q as a, V as c, F as d, N as f, G as i, z as l, E as m, J as n, X as o, M as p, Y as r, Z as s, H as t, L as u };

//# sourceMappingURL=skill-files-B3jqIKk3.js.map